<script>
import Layout from '@layouts/main'
import LayoutMember from '@layouts/LayoutMember'
import { merchantComputed } from '@state/helpers'
import formatDate, { dateDiffInMinutes } from '@utils/format-date'
import { parseStringToDateTime } from '@utils/parse-string-to-date'

export default {
  page() {
    return {
      title: this.$t('global.MEMBER_ORDER'/* 預訂紀錄 */),
    }
  },
  components: { Layout, LayoutMember },
  filters: {
    formatDate,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDeductProcessing: false,
      defaultImage: require('@assets/images/activity_default.png'),
    }
  },
  computed: {
    ...merchantComputed,
    paramsSizeTotal() {
      let size = 0;

      this.order.params.forEach(param => {
        size += param.size * param.qty
      });

      return size
    },
    gender() {
      const gender = {
        male: this.$t('global.MALE' /* 先生 */),
        female: this.$t('global.FEMALE' /* 小姐 */),
      };

      return gender[this.order.gender]
    },
    paymentMethod() {
      const paymentMethod = {
        prepaid: this.$t('global.PAYMENT_METHOD_PREPAID' /* 預付抵用 */),
        cash: this.$t('global.PAYMENT_METHOD_CASH' /* 現金付款 */),
        creditCard: this.$t('global.PAYMENT_METHOD_CREDITCARD' /* 信用卡付款 */),
        free: this.$t('global.PAYMENT_METHOD_FREE' /* 免費 */),
      };
      return paymentMethod[this.order.paymentMethod]
    },
    timeInterval() {
      const dateDiff = dateDiffInMinutes(`${this.order.startDate}`, `${this.order.endDate}`);

      if(dateDiff > 60 * 24 * 30) {
        return this.$tc('global.ABOUT_TIME_MOUTH', dateDiff / (60 * 24 * 30), { minute: Math.floor(dateDiff / (60 * 24 * 30)) }/* (預計{minute}個月) */)
      }else if(dateDiff > 60 * 24) {
        return this.$tc('global.ABOUT_TIME_DAY', dateDiff / (60 * 24), { minute: Math.floor(dateDiff / (60 * 24)) }/* (預計{minute}天) */)
      }else if(dateDiff > 60) {
        return this.$tc('global.ABOUT_TIME_HOUR', dateDiff / 60, { minute: Math.floor(dateDiff / 60) }/* (預計{minute}小時) */)
      }else {
        return this.$tc('global.ABOUT_TIME_MINUTE', dateDiff, { minute: Math.floor(dateDiff) }/* (預計{minute}分鐘) */)
      }
    },
    isNullOrder() {
      return typeof this.order === 'object' && Object.keys(this.order).length === 0
    }
  },
  methods: {
    handleCancel() {
      const vnodes = [];

      if (this.order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${this.order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {this.order.merchant.email}
      </a>
      )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${this.order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {this.order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(
        messageElement,
        this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_TITLE',
          {
            actionName: this.$t(
              `product.${this.order.productType}.ORDER_CANCEL`
            ),
            merchantName: this.order.merchant.name,
          } /* 取消預訂請聯繫{merchantName} */
        ),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t(
            'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
          ),
          confirmButtonClass: 'button is-primary is-rounded',
        }
      )
    },
    handleContact() {
      const vnodes = []

      if (this.order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${this.order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {this.order.merchant.email}
      </a>
      )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${this.order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {this.order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(messageElement, this.$t('global.CONTACT_PREFIX', { name: this.order.merchant.name }/* 聯繫{name} */), {
        distinguishCancelAndClose: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
        ),
        confirmButtonClass: 'button is-primary is-rounded',
      })
    },
    orderStatusAlias(orderStatus) {
      const statusAliasMap = [
        'cancel',
        'paid',
        'unpaid',
      ];

      return statusAliasMap[orderStatus]
    },
    orderStatusText() {
      const status = {
        'cash': [
          this.$t('global.CANCELED' /* 已取消 */),
          this.$t('global.PAID' /* 已付款 */),
          this.$t('global.UNPAID' /* 未付款 */),
        ],
        'prepaid': [
          this.$t('global.CANCELED' /* 已取消 */),
          this.$t('global.DEDUCTED' /* 已抵用 */),
          this.$t('global.CONFIRMED' /* 待確認 */),
        ]
      };

      return status[this.order.prepaid ? 'prepaid' : 'cash'][this.order.status]
    },
    orderStatusClass(orderStatus) {
      const statusClassMap = {
        0: 'is-orange',
        1: 'is-primary',
        2: 'is-danger',
      };
      return statusClassMap[orderStatus]
    },
    googleCalendarUrl(order) {
      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
      const text = order.productName || '';
      const start = order.startDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T');
      const end = order.endDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T');
      const dates = `${start}/${end}`;
      const details = order.productDescription || '';
      const location = order.productAddress || '';
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`;

      return `http://www.google.com/calendar/event?${query}`
    },
    orderIsCanPay(order) {
      const isExpired = parseStringToDateTime(order.startDate) <= new Date();
      const isAllowExpired = order.allowExpired;

      return !isExpired || (isExpired && isAllowExpired)
    },
    handleToBookingDeductUnpaid(order) {
      this.isDeductProcessing = true;

      this.$store.dispatch('booking/fetchOrderDeduct', {
        orderKey: order.id
      })
        .then((response) => {
          window.globalData.order = {
            status: 'SUCCESS',
            type: 'deduct'
          };

          this.$router.push({
            name: 'order-detail',
            params: {
              orderKey: response.items.id
            },
            query: {
              language: this.$route.query.language,
            }
          })
        })
        .finally(() => {this.isDeductProcessing = false});
    }
  },
}
</script>
<template>
  <Layout>
    <LayoutMember>
      <template v-if="!isNullOrder">
        <div class="booking-section">
          <div class="level subsection is-tab-style">
            <div class="level-left booking-section__title">
              <router-link
                :to="{
                name: 'member-order',
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
                class="is-link-black"
              >
                <BaseIcon name="angle-left" style="margin-right: 0.5rem"/>
                <span class="is-size-6">{{ $t('global.BACK_LIST'/*回列表頁*/) }}</span>
              </router-link>
            </div>
            <div class="level-right buttons is-tab-style">
              <router-link
                class="button is-tab-style"
                :class="{ 'is-active': $route.name === 'member-order-item' }"
                :to="{
                name: 'member-order-item',
                params: {
                  orderKey: order.id,
                },
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.MEMBER_ORDER_DETAIL'/*訂單詳情*/) }}
              </router-link>
              <router-link
                v-if="orderStatusAlias(order.status) === 'paid'"
                class="button is-tab-style"
                :class="{ 'is-active': $route.name === 'member-order-ticket' }"
                :to="{
                name: 'member-order-ticket',
                params: {
                  orderKey: order.id,
                },
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.QRCODE'/*QR Codes*/) }}
              </router-link>
            </div>
          </div>
          <div class="subsection product-wrapper">
            <div :class="$style.wrapper">
              <div :class="$style.inner" class="is-mobile-column-reverse">
                <div class="columns is-multiline is-mobile is-mobile-column-reverse">
                  <div class="column is-full-mobile is-half-tablet">
                    <div class="media is-align-items-stretch">
                      <figure class="media-left">
                        <picture>
                          <BaseImage
                            :src="order.introimage"
                            :error-src="defaultImage"
                            :class="$style.image"
                            class-name="is-cover"
                          />
                        </picture>
                      </figure>
                      <div class="media-content">
                        <div :class="$style.titleBox" class="level" style="margin-bottom: 0.5rem">
                          <div :class="$style.title" class="level-left">
                            <b-tag :type="orderStatusClass(order.status)" rounded style="margin-right: 0.5rem">
                              {{orderStatusText(order.status) }}
                            </b-tag> {{ order.productName }}
                          </div>
                        </div>
                        <div class="has-text-grey-light is-text-content">
                          {{ order.merchant.name }}
                          <br>{{ $t(`product.activity.TITLE_TIME`/*活動時間*/) }}：{{order.startDate |
                          formatDate('dateTime')}}{{timeInterval}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-full-mobile is-half-tablet">
                    <div>
                      <div class="level" style="margin-bottom: 0">
                        <div class="level-left"></div>
                        <div class="level-right">
                          <div class="has-text-grey-light" style="margin-bottom: 1rem">{{ $t('global.ORDER_NO'/*訂單編號*/) }} #{{order.orderNo}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="$style.inner">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-one-fifth-tablet is-full-mobile">
                    {{ $t('global.ORDER_DETAIL' /* 訂單明細 */) }}
                  </div>
                  <template>
                    <div v-if="order.prepaid" class="column">
                      <div v-for="(param, index) in order.params" :key="index" class="level is-mobile" style="margin-bottom: 0.5rem;">
                        <div class="level-left">
                          {{param.name}} x {{param.qty}}
                        </div>
                        <div class="level-right">
                    <span class="has-text-right">
                      {{ $t('global.TOTAL_DEDUCT', { size: param.qty } /* 抵用 {size} 次 */) }}
                    </span>
                        </div>
                      </div>
                      <hr :class="$style.hr">
                      <div class="level is-mobile" style="margin-bottom: 0.5rem">
                        <div class="level-left">
                          {{ $t('global.USE_PREPAID'/*使用方案*/) }}
                        </div>
                        <div class="level-right has-text-primary">
                          <router-link :to="{ name: 'member-prepaid-item', params: { orderKey: order.prepaid.id }, query: { language: $route.query.language }

                     }">
                            {{order.prepaid.title}}
                          </router-link>
                        </div>
                      </div>
                      <hr :class="$style.hr">
                      <div class="level is-mobile" >
                        <div class="level-left">
                          {{ $t('global.TOTAL'/*總計*/) }}
                        </div>
                        <div class="level-right">
                    <span class="has-text-right is-size-6">
                      {{ $t('global.TOTAL_DEDUCT', { size: order.prepaid.deductTimes } /* 抵用 {size} 次 */) }}
                    </span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="column">
                      <div v-for="(param, index) in order.params" :key="index" class="level is-mobile" style="margin-bottom: 0.5rem;">
                        <div class="level-left">
                          {{param.name}} x {{param.qty}}
                        </div>
                        <div class="level-right">
                    <span class="has-text-grey-light">
                      {{param.size * param.qty}} <BaseIcon name="ticket-alt" />
                    </span>
                          <span class="has-text-right has-text-grey" style="min-width: 80px;">
                      ${{param.total}}
                    </span>
                        </div>
                      </div>
                      <hr :class="$style.hr">
                      <div class="level is-mobile" style="margin-bottom: 0.5rem">
                        <div class="level-left">
                          {{ $t('global.SUBTOTAL'/*小計*/) }}
                        </div>
                        <div class="level-right">
                          ${{order.priceBase}}
                        </div>
                      </div>
                      <div v-if="order.couponTitle && order.couponCode" class="level is-mobile" >
                        <div class="level-left">
                          {{ $t('global.COUPON'/*優惠券*/) }} ({{order.couponTitle}}：{{order.couponCode}})
                        </div>
                        <div class="level-right has-text-grey">
                          ${{order.priceTotal - order.priceBase}}
                        </div>
                      </div>
                      <hr :class="$style.hr">
                      <div class="level is-mobile" >
                        <div class="level-left">
                          {{ $t('global.TOTAL'/*總計*/) }}
                        </div>
                        <div class="level-right">
                    <span>
                      {{paramsSizeTotal}} <BaseIcon name="ticket-alt" />
                    </span>
                          <span class="has-text-right is-size-6" style="min-width: 80px;">
                      ${{order.priceTotal}}
                    </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div :class="$style.inner">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-one-fifth-tablet is-full-mobile">
                    {{ $t('global.ORDER_INFO'/*訂單資訊*/) }}
                  </div>
                  <div class="column is-text-content has-text-grey">
                    <div v-if="order.created">
                      <span>{{ $t('global.ORDER_CREATED'/*訂單成立時間*/) }}：</span>
                      <span>{{order.created | formatDate('dateTimeWeekDay')}}</span>
                    </div>
                    <div v-if="order.paidDate">
                      <span>{{ $t('global.ORDER_PAID'/*訂單完成時間*/) }}：</span>
                      <span>{{order.paidDate | formatDate('dateTimeWeekDay')}}</span>
                    </div>
                    <div v-if="order.cancelDate">
                      <span>{{ $t('global.ORDER_CANCEL'/*訂單取消時間*/) }}：</span>
                      <span>{{order.cancelDate | formatDate('dateTimeWeekDay')}}</span>
                    </div>
                    <div v-if="order.paymentMethod">
                      <span>{{ $t('global.PAYMENT_METHOD'/*付款方式*/) }}：</span>
                      <span>{{paymentMethod}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="$style.inner">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-one-fifth-tablet is-full-mobile">
                    {{ $t('global.ORDER_USE_INFO'/*使用資訊*/) }}
                  </div>
                  <div class="column is-text-content has-text-grey">
                    <div>
                      {{ $t('global.ORDER_USE_INFO_NAME'/*使用人姓名*/) }}：{{order.fullName}} {{gender}}
                    </div>
                    <div>
                      {{ $t('global.ORDER_USE_INFO_PHONE'/*使用人電話*/) }}：{{order.phoneCode}} {{order.phoneNumber}}
                    </div>
                    <div>
                      {{ $t('global.ORDER_USE_INFO_EMAIL'/*使用人Email*/) }}：{{order.email}}
                    </div>
                    <div>
                      {{ $t('global.ORDER_USE_INFO_NOTE'/*其他備註*/) }}：<span v-if="order.note">{{order
                  .note}}</span><span v-else>{{ $t('global.ORDER_USE_INFO_NOTE_NULL'/*無*/) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="subsection">
            <div v-if="orderStatusAlias(order.status) === 'unpaid'" class="buttons">
              <template v-if="order.prepaid">
                <b-button
                  v-if="orderIsCanPay(order)"
                  type="is-primary"
                  rounded
                  class="is-fullwidth"
                  :loading="isDeductProcessing"
                  @click="handleToBookingDeductUnpaid(order)"
                >{{ $t('global.CONFIRMED_DEDUCT'/*確認抵用*/) }}</b-button>
              </template>
              <template v-else>
                <router-link
                  v-if="orderIsCanPay(order)"
                  class="button is-primary is-rounded is-fullwidth"
                  :to="{
                  name: 'booking-unpaid-checkout',
                  params: {
                    merchantAlias: order.merchant.alias,
                    productId: order.productAlias,
                    orderKey: order.id,
                  },
                  query: {
                    language: $route.query.language,
                  },
                }"
                >
                  {{ $t('global.PAYMENT_NOW'/* 前往付款 */) }}
                </router-link>
              </template>
              <router-link
                class="button is-primary is-rounded is-outlined is-fullwidth"
                :to="{
                name: 'member-order',
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.BACK_LIST'/*回列表*/) }}
              </router-link>
              <router-link
                class="button is-black is-rounded is-outlined is-fullwidth"
                :to="{
                name: 'booking-product',
                params: {
                  merchantAlias: order.merchant.alias,
                  productId: order.productAlias,
                },
                query: {
                  language: $route.query.language,
                },
              }"
              >
                {{ $t(`product.${order.productType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
              </router-link>
              <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
              <b-button
                type="is-black"
                rounded
                class="button is-rounded is-outlined is-fullwidth"
                @click="handleCancel"
              >{{ $t(`product.${order.productType}.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
            </div>
            <div v-if="orderStatusAlias(order.status) === 'paid'" class="buttons">
              <router-link
                class="button is-primary is-rounded is-fullwidth"
                :to="{
                name: 'member-order-ticket',
                params: {
                  orderKey: order.id,
                },
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.ADMISSION_QRCODE'/* 使用 QR Code */) }}
              </router-link>
              <router-link
                class="button is-primary is-rounded is-outlined is-fullwidth"
                :to="{
                name: 'member-order',
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.BACK_LIST'/*回列表*/) }}
              </router-link>
              <a
                target="_blank"
                :href="googleCalendarUrl(order)"
                class="button is-rounded is-outlined is-fullwidth is-black"
              >{{ $t('global.ADD_CALENDAR'/* 加入行事曆 */) }}</a>
              <router-link
                class="button is-black is-rounded is-outlined is-fullwidth"
                :to="{
                name: 'booking-product',
                params: {
                  merchantAlias: order.merchant.alias,
                  productId: order.productAlias,
                },
                query: {
                  language: $route.query.language,
                },
              }"
              >
                {{ $t(`product.${order.productType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
              </router-link>
              <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
              <b-button
                type="is-black"
                rounded
                class="button is-rounded is-outlined is-fullwidth"
                @click="handleCancel"
              >{{ $t(`product.${order.productType}.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
            </div>
            <div v-if="orderStatusAlias(order.status) === 'cancel'" class="buttons">
              <router-link
                class="button is-primary is-rounded is-outlined is-fullwidth"
                :to="{
                name: 'member-order',
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
              >
                {{ $t('global.BACK_LIST'/*回列表*/) }}
              </router-link>
              <router-link
                class="button is-black is-rounded is-outlined is-fullwidth"
                :to="{
                name: 'booking-product',
                params: {
                  merchantAlias: order.merchant.alias,
                  productId: order.productAlias,
                },
                query: {
                  language: $route.query.language,
                },
              }"
              >
                {{ $t(`product.${order.productType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="booking-section--outside">
          <b-button
            type="is-black"
            rounded
            outlined
            class="is-fullwidth"
            @click="handleContact"
          >{{ $t('global.CONTACT_MERCHANT'/* 聯絡商家 */) }}</b-button>
        </div>
      </template>
      <template v-else>
        <div class="defaultBox">
          <img alt="merchant default" class="defaultBox__image" src="@assets/images/information_default.png" />
          <h3 class="defaultBox__text">
            {{$t('global.NOT_FOUND_PREFIX', { text: $t('global.ORDER') } /*找不到訂單*/)}}
          </h3>
        </div>
        <router-link
          class="button is-primary is-rounded is-fullwidth"
          :to="{ name: 'member-order', query: { language: $route.query.language, merchant: $route.query.merchant } }"
        >
          回列表
        </router-link>
      </template>
    </LayoutMember>
  </Layout>
</template>
<style lang="scss" module>
  .wrapper {
    &:not(:last-child) {
      .inner {
        border-bottom: 1px solid $color-border-base;
      }
    }
    .inner:not(:last-child) {
      border-bottom: 1px solid $color-border-base;
    }

    .inner {
      padding: 1rem 0 0.9rem;
      margin: 0 1.5rem;
    }
  }

  .titleBox {
    align-items: flex-start;
    margin-bottom: 1rem;
    .title {
      max-width: 388px;
      align-items: flex-start;
    }
  }

  .image {
    height: 100px;
    width: 150px;
    overflow: hidden;
    background: $grey-lighter no-repeat;
    border-radius: $size-image-border-radius;
    position: relative;
    background-size: cover;
    @include mobile {
      width: 100px;
      height: 70px;
    }
  }
  .hr {
    border-bottom: 1px dashed $color-border-base;
    margin: 1rem 0;
    background: transparent;
  }
</style>
